import { getRequest, postRequest } from './request';

export const recruitJsonAjaxAnalyze = async ({ jobId, revisionId }) => {
  const key = window.sessionStorage.shareKey || '';

  const data = await postRequest({
    url: '/recruit-json/ajax-analyze',
    body: { job: jobId, revision: revisionId, key },
  });

  return { redirect: data.redirect, jobId: String(data.jobId), key: data.key };
};

export const recruitJsonCreate = async ({
  title,
  location,
  template,
  isPrivate,
  isTemplate,
  flexibleId,
}) => {
  const data = await postRequest({
    url: '/recruit-json/create',
    body: {
      title,
      location,
      template,
      private: isPrivate,
      is_template: isTemplate,
      flexible_id: flexibleId,
    },
  });

  return { success: data.success, message: data.message, jobId: data.jobId };
};

export const recruitJsonGetTemplates = async () => {
  const data = await getRequest({ url: '/recruit-json/get-templates' });
  return {
    success: data.success,
    templates: [...data.templates],
    projectName: data.projectName,
  };
};

// TODO: test post with no body
export const recruitJsonMakePublic = async ({
  jobId,
}) => postRequest({
  url: `/recruit-json/make-public?id=${jobId}`,
});

export const recruitJsonMakePrivateMe = async ({
  jobId,
}) => postRequest({
  url: `/recruit-json/make-private-me?id=${jobId}`,
});

export const recruitJsonMakePrivateUs = async ({
  jobId,
}) => postRequest({
  url: `/recruit-json/make-private-us?id=${jobId}`,
});

export const recruitJsonDelete = async ({
  jobId,
}) => postRequest({
  url: `/recruit-json/delete?id=${jobId}`,
  body: { id: jobId },
});

export const recruitJsonMakeHidden = async ({
  jobId, isHidden,
}) => postRequest({
  url: `/recruit-json/make-hidden?id=${jobId}`,
  body: { is_hidden: isHidden },
});

export const recruitJsonDeleteTemplate = async ({
  jobId,
}) => postRequest({
  url: `/recruit-json/delete-template?id=${jobId}`,
  body: { id: jobId },
});

export const recruitJsonDuplicate = async ({ jobId, title, from }) => {
  const data = await postRequest({
    url: '/recruit-json/duplicate',
    body: { id: jobId, title, from },
  });
  return { success: data.success, id: data.id, title: data.title };
};

export const recruitJsonMakeDefault = async ({
  jobId,
}) => postRequest({
  url: `/recruit-json/make-default?id=${jobId}`,
  body: { id: jobId },
});

export const recruitJsonApplyTemplate = async ({
  jobId, templateId, actionType,
}) => {
  const shareKey = window.sessionStorage.shareKey || '';

  const data = await postRequest({
    url: '/recruit-json/apply-template',
    body: {
      job: jobId, template: templateId, actionType, shareKey,
    },
  });
  return { success: data.success, referrer: data.referrer, newRevisionId: data.newRevisionId };
};

export const recruitJsonDuplicateFlagship = async (jobId) => {
  const data = await postRequest({
    url: `/recruit-json/make-flagship?id=${jobId}`,
  });
  return { success: data.success, id: data.id, title: data.title };
};

export const recruitJsonUnmakeFlagship = async ({ jobId }) => {
  const data = await postRequest({
    url: `/recruit-json/unmake-flagship?id=${jobId}`,
  });

  return { success: data.success };
};

export const searchJobPostsForWizard = async ({ title = '', jobCode = '' } = {}) => {
  const data = await postRequest({
    url: '/recruit-json/search-for-create',
    body: { title, job_code: jobCode },
  });
  return { jobs: data.jobs || [] };
};

export const previewJobPostFromWizard = async ({ templateId, similarJobId } = {}) => {
  const data = await postRequest({
    url: '/recruit-json/preview-from-wizard',
    body: { template_id: templateId, similar_job_id: similarJobId },
  });
  return { fields: data.fields || [] };
};

export const createJobPostFromWizard = async ({
  title, location, jobCode, templateId, similarJobId,
}) => {
  const data = await postRequest({
    url: '/recruit-json/create-from-wizard',
    body: {
      title,
      location,
      job_code: jobCode,
      template_id: templateId,
      similar_job_id: similarJobId,
    },
  });
  return { success: data.success, jobId: data.jobId };
};
